export default __webpack_public_path__ + "2687aba405683d4688f2818f7620cfda.svg";